import React from 'react';
import './WhoShouldEnroll.css';
import { GraduationCap, Briefcase, Repeat, Users } from 'lucide-react';

const audience = [
  {
    icon: <GraduationCap size={28} />,
    title: 'Freshers & Graduates',
    desc: 'Kickstart your career with in-demand industry skills and hands-on projects.',
  },
  {
    icon: <Briefcase size={28} />,
    title: 'Working Professionals',
    desc: 'Upgrade your skills or shift to a tech role with our structured learning.',
  },
  {
    icon: <Repeat size={28} />,
    title: 'Career Switchers',
    desc: 'Transition smoothly into the tech world from non-technical backgrounds.',
  },
  {
    icon: <Users size={28} />,
    title: 'Entrepreneurs & Freelancers',
    desc: 'Build, launch, and manage your own web products independently.',
  },
];

const WhoShouldEnroll = () => {
  return (
    <section className="who-should-enroll-container">
      <div className="who-should-enroll-wrapper">
        <h2 className="who-should-enroll-title">Who Should Enroll?</h2>
        <p className="who-should-enroll-subtitle">
          This course is designed to support learners at every stage of their journey.
        </p>

        <div className="who-should-enroll-grid">
          {audience.map((item, index) => (
            <div key={index} className="who-should-enroll-card">
              <div className="who-should-enroll-icon-box">{item.icon}</div>
              <h3 className="who-should-enroll-card-title">{item.title}</h3>
              <p className="who-should-enroll-card-desc">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoShouldEnroll;
